<template>
  <div>
    <el-dialog :title="title"
               :width="width"
               :visible.sync="visible"
               @close="$emit('update:show', false)"
               :show="show">
      <slot name='dialogContent'></slot>
      <span slot="footer"
            class="dialog-footer"
            v-if="isFooter">
        <el-button @click="$emit('update:show', false)">取 消</el-button>
        <el-button type="primary"
                   @click="$emit('handle', false)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: this.show
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '600px'
    },
    isFooter: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    }
  },
  watch: {
    show () {
      this.visible = this.show
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  box-shadow: 0 0 5px #ccc;
  padding: 10px 20px 10px;
  .el-dialog__title {
    font-size: 16px;
    color: #555;
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
}

::v-deep .el-dialog__footer {
  box-shadow: 0 0 5px #ccc;
  padding: 10px 20px;
  .dialog-footer {
    display: block;
  }
  .el-button {
    width: 65px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    padding: 0;
  }
}
</style>
